type CTALink = {
  title: string;
  href: string;
  target: string;
};

export const extractCTALink = (html: string): CTALink | null => {
  if (globalThis?.DOMParser == null) {
    return null;
  }

  const parser = new globalThis.DOMParser();
  const document_ = parser.parseFromString(html, 'text/html');

  const link = document_.querySelector('a');

  if (!link) return null;

  return {
    href: link.getAttribute('href') ?? '',
    title: link.getAttribute('title') ?? '',
    target: link.getAttribute('target') ?? '',
  };
};
